module.exports = __webpack_public_path__ + "images/top_bg.gif";